var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.652 3.34818C16.2122 2.9084 15.4992 2.9084 15.0594 3.34818L7.52236 10.8852V12.4778H9.11494L16.652 4.94076C17.0918 4.50098 17.0918 3.78796 16.652 3.34818ZM14.1038 2.39263C15.0714 1.42511 16.64 1.42511 17.6075 2.39263C18.575 3.36014 18.575 4.92879 17.6075 5.89631L9.87259 13.6313C9.74587 13.758 9.57401 13.8292 9.39481 13.8292H6.84668C6.47352 13.8292 6.17101 13.5266 6.17101 13.1535L6.17101 10.6053C6.17101 10.4261 6.24219 10.2543 6.36891 10.1276L14.1038 2.39263ZM4.14398 4.82015C3.52204 4.82015 3.01785 5.32433 3.01785 5.94627V15.8562C3.01785 16.4781 3.52204 16.9823 4.14398 16.9823H14.0539C14.6758 16.9823 15.18 16.4781 15.18 15.8562V11.3517C15.18 10.9785 15.4825 10.676 15.8557 10.676C16.2289 10.676 16.5314 10.9785 16.5314 11.3517V15.8562C16.5314 17.2245 15.4222 18.3337 14.0539 18.3337H4.14398C2.77571 18.3337 1.6665 17.2245 1.6665 15.8562V5.94627C1.6665 4.578 2.77571 3.4688 4.14398 3.4688H8.64848C9.02165 3.4688 9.32416 3.77131 9.32416 4.14447C9.32416 4.51764 9.02165 4.82015 8.64848 4.82015H4.14398Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyEdit);
export default __webpack_public_path__ + "static/media/grey-edit.59c2a7f6f4bb5d1ebd42732228d3ebef.svg";
export { ForwardRef as ReactComponent };